import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import WarehouseDatatable from './WarehouseDatatable';
import WarehouseModal from './WarehouseModal';



const WarehouseListTab = (props) => {

    
    const [show , setShow]= useState( false );
    const [recordId, setRecordId ] = useState();    

    const [showAndRecordId , setShowAndRecordId]= useState( {
      show: false,
      recordId: ''
    } );
  

    const handleCallback = (id,action) => {
       switch(action){
          case "new":          
              setShowAndRecordId({
                  show: true,
                  recordId: id
              });
           break;
           case "edit":
              //setRecordId(id);       
              //setShow(true);   
              setShowAndRecordId({
                show: true,
                recordId: id
              });
            break;
            case "status":
              props.parentCallback(id,action) ;
            break;
            default:
       }
    };
 
    const modalCallback = (show,id) => {             
     // setRecordId(id);  
     // setShow(show);      
      setShowAndRecordId({
        show: show,
        recordId: id
      });     
    }

  
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <WarehouseDatatable            
            parentCallback={handleCallback}    
            modalShow={showAndRecordId.show}                                
          />
         
          <WarehouseModal 
            modal={showAndRecordId.show}
            parentCallback={modalCallback}
            selectedRecord={showAndRecordId.recordId}                      
          />
         
          <Button
            bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('','new')} 
          >
            <i class="fas fa-plus"></i>
          </Button>
        </div>
    );
};

export default WarehouseListTab;